import type { Quantity } from 'constants/products';
import { C62 } from 'constants/weightOptions';

export const getDefaultUom = ({
  suggestedQuantity,
  defaultQuantity,
  uoms,
}: {
  suggestedQuantity?: Pick<Quantity, 'uom'>;
  defaultQuantity?: Pick<Quantity, 'uom'>;
  uoms?: string[];
}): string => suggestedQuantity?.uom ?? defaultQuantity?.uom ?? uoms?.[0] ?? C62;
